import { css } from '@emotion/core'

const colors = {
  // info: '58, 137, 196',
  // info: '155, 89, 182',
  // info: '7, 153, 146',
  info: '87, 88, 187',
}

export const styles = {
  base: css`
    padding: 10px;
    margin-top: 12px;

    font-size: 14px;
    border-radius: 3px;

    line-height: 1.5em;
  `,

  error: css`
    color: rgb(235, 87, 87);
    * {
      color: rgb(235, 87, 87);
    }

    background: rgba(235, 87, 87, 0.06);
    box-shadow: rgba(15, 15, 15, 0.1) 0px 1px 2px,
      rgba(235, 87, 87, 0.3) 0px 0px 0px 1px inset;
  `,

  info: css`
    color: rgb(${colors.info});
    * {
      color: rgb(${colors.info});
    }

    background: rgba(${colors.info}, 0.06);
    box-shadow: rgba(15, 15, 15, 0.1) 0px 1px 2px,
      rgba(${colors.info}, 0.3) 0px 0px 0px 1px inset;
  `,

  success: css`
    color: rgb(16, 172, 132);
    * {
      color: rgb(16, 172, 132);
    }

    background: rgba(16, 172, 132, 0.06);
    box-shadow: rgba(15, 15, 15, 0.1) 0px 1px 2px,
      rgba(16, 172, 132, 0.3) 0px 0px 0px 1px inset;
  `,
}
